import {RootState} from '../../../store';

export const getOCRPassed = (state: RootState) =>
  state.identityVerification.ocrResultData.ocrPassed;
